import Munio from "@vhiweb/munio-client-js";
import config from "./config";
import { getSessionForLoginUser } from "./utils/cookie";
import axios from "axios";

export class MunioClientV2 extends Munio {
    private clientKey = config.CLIENT_KEY;

    async getClientKey(url?: any) {
        if (this.clientKey) {
            return this.clientKey;
        } else {
            const reqOptions = {
                url: `${config.BASE_URL_V2}/clients/key`,
                method: "POST",
                headers: {
                    Accept: "*/*",
                    "Content-Type": "application/json",
                },
                data: {
                    url: url,
                },
            };
            try {
                const response = await axios.request(reqOptions);
                if (response) {
                    return response?.data?.clientKey;
                }
            } catch (e) {
                return e;
            }
        }
    }

    async initMunio(key?: string) {
        this.init({
            host: config.BASE_URL_V2,
            client: key,
            AppKey: getSessionForLoginUser() || "",
        });
    }
}

export const MUNIO_V2 = new MunioClientV2();
